export interface IUpdateTCRequest {
    accepted: boolean;
    tcVersion: string;
    timestamp: string;
}

export class UpdateTCRequest implements IUpdateTCRequest {
    public accepted: boolean;
    public tcVersion: string;
    public timestamp: string;

    constructor(accepted: boolean, tcVersion: string, timestamp: string){
        this.accepted = accepted;
        this.tcVersion = tcVersion;
        this.timestamp = timestamp;
    }
}